import React, { Component } from "react";
import {Link} from "react-router-dom";

const PortfolioListContent = [
    {
        image: 'image-1',
        title: 'Digital Marketing',
        buttonLink: '/digital-marketing'
    },
    {
        image: 'image-4',
        title: 'Web Design & Development',
        buttonLink: '/web-design-development'
    },
    {
        image: 'image-3',
        title: 'Sales and Marketing Automation',
        buttonLink: '/sales-and-marketing-automation'
    },
    {
        image: 'image-2',
        title: 'Industrial Solution',
        buttonLink: '/industrial-solutions'
    },
]

class PortfolioList extends Component{
    render(){
        const {column , styevariation } = this.props;
        const list = PortfolioListContent.slice(0 , this.props.item);
        return(
            <React.Fragment> 
                {list.map((value , index) => (
                    <div className={`${column}`} key={index}>
                        <div className={`portfolio ${styevariation}`}>
                            <div className="thumbnail-inner">
                                <div className={`thumbnail ${value.image}`}></div>
                                <div className={`bg-blr-image ${value.image}`}></div>
                            </div>
                            <div className="content">
                                <div className="inner">
                                    <p>{value.category}</p>
                                    <h4><a href={value.buttonLink}>{value.title}</a></h4>
                                    <div className="portfolio-button">
                                        <a className="rn-btn" href={value.buttonLink}>View Details</a>
                                    </div>
                                </div>
                            </div>
                            <Link className="link-overlay" to={value.buttonLink}></Link>
                        </div>
                    </div>
                ))}
               
            </React.Fragment>
        )
    }
}
export default PortfolioList;